import { render, staticRenderFns } from "./SoftwareApply.vue?vue&type=template&id=a956d8b8&scoped=true"
import script from "./SoftwareApply.vue?vue&type=script&lang=js"
export * from "./SoftwareApply.vue?vue&type=script&lang=js"
import style0 from "./SoftwareApply.vue?vue&type=style&index=0&id=a956d8b8&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a956d8b8",
  null
  
)

export default component.exports